import { render, staticRenderFns } from "./PaginaList.vue?vue&type=template&id=19cd4dce&"
import script from "./PaginaList.vue?vue&type=script&lang=js&"
export * from "./PaginaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports